export function setStyle(element, attr) {
  if (!element || !attr) {
    return;
  }
  for (var key in attr) {
    element.style[key] = attr[key];
  }
}
/**
 * 获取执行元素的属性值
 * @param element
 * @param attr
 * @returns {string}
 */
export function getStyle(element, attr) {
  try {
    var style = getComputedStyle ? getComputedStyle(element, null) : document.defaultView.getComputedStyle(element, null);
    return attr ? style[attr] : style;
  } catch (e) {
    return '0';
  }
}
/**
 * 获取元素行间样式
 * @param element
 * @param attr
 * @returns {string}
 */
export function getLineStyle(element, attr) {
  if (!element || !element.style) {
    return attr ? null : {};
  }
  return attr ? element.style[attr] : element.style;
}
export function getStyleValue(element, attr) {
  var str = getStyle(element, attr);
  var value = parseFloat(str);
  return isNaN(value) ? 0 : value;
}
export function contains(root, child) {
  var node = child;
  while (node) {
    if (node === root) {
      return true;
    }
    node = node.parentNode;
  }
  return false;
}